<template lang="pug">

    .ui.icon.message
        i.inbox.icon
        .content
            .header Lieferanten-AB wurde am {{ date }} um {{ time }} Uhr angefordert
            p
                | Die Auftragsbestätigung kann
                a(v-bind:href="uploadUrl" target='_blank')  hier
                |  hochgeladen werden.

</template>

<script>

    import * as R from "ramda";
    import {to_ddmmyyyy, to_hhmm} from "@/utils/date";

    export default {

        computed: {

            date() {
                return to_ddmmyyyy(R.prop('createdDate', this.orderConfirmationRequestModel))
            },

            time() {
                return to_hhmm(R.prop('createdDate', this.orderConfirmationRequestModel))
            },

            uploadUrl() {
                const oCRId = this.orderConfirmationRequestModel.id
                const uploadId = this.uploadModel.id
                const accessKey = this.uploadModel.accessKey
                return `/uploads/order-confirmations/${oCRId}/${uploadId}?access-key=${accessKey}`
            }

        },

        props: {

            orderConfirmationRequestModel: {
                type: Object,
                default: R.always({})
            },

            uploadModel: {
                type: Object,
                default: R.always({})
            }

        }

    }

</script>
